import { App, Button, Card, Form, Select, Space, Table } from 'antd';
import { useEffect, useState } from 'react';
import { GET, POST } from '../../utils/apicalls';
import { API } from '../../config/api';
import LayoutHeader from '../../adminnavigation/layoutHeader';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

function PaymentDetails() {
    const [isLoading, setIsLoading] = useState(false);
    const [bookingData, setBookingData] = useState<any[]>([]);
    const [courses, setCourses] = useState<any[]>([]);
    const [filteredData, setFilteredData] = useState<any[]>([]);
    const { notification } = App.useApp();
    const [form] = Form.useForm();

    const fetchAllBookingDetails = async () => {
        try {
            setIsLoading(true);
            const response: any = await GET(API.GET_ALL_PAYMENT_DETAILS, {});
            setBookingData(response?.data || []);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    const fetchAllCourses = async () => {
        try {
            setIsLoading(true);
            const response: any = await GET(API.GET_ALL_COURSES, {});
            setCourses(response?.data || []);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchAllBookingDetails();
        fetchAllCourses();
    }, []);

    const filterBookingData = async (values: any) => {
        try {
            setIsLoading(true);
            const response: any = await POST(API.FILTER_BOOKING_DETAILS, values);

            if (response?.status && response.data.length > 0) {
                setFilteredData(response.data);
            } else {
                setFilteredData([]);
                notification.info({ message: 'No data found for the selected course.' });
            }
        } catch (error) {
            console.error(error);
            notification.error({ message: 'An error occurred while filtering.' });
        } finally {
            setIsLoading(false);
        }
    };

    const downloadFullTableAsPDF = (data: any[], courses: any[]) => {
        const doc = new jsPDF();
        doc.text("Full Booking Data", 10, 10);

        if (!data?.length) {
            doc.text("No data available.", 10, 20);
            doc.save("Full-Booking-Data.pdf");
            return;
        }

        const head = [
            "#",
            "Payment Amount",
            "Payment Status",
            "Created At",
            "User Name",
            "Course",
            "Coupon",
        ];

        const body = data.map((item, index) => {
            // ✅ Get course id safely
            const bookingCourseId =
                item.Course_id ||
                item.bookingdetails?.Course_id ||
                item.courseId;

            // ✅ Match against all possible course keys
            const course = courses.find((c: any) =>
                c.id === bookingCourseId ||
                c.Course_id === bookingCourseId ||
                c.course_id === bookingCourseId
            );

            return [
                index + 1,
                item.paymentamount ?? "-",
                item.paymentstatus ?? "-",
                item.createdAt ?? "-",
                item.bookingdetails?.UserName ?? "-",
                course?.course_title || course?.title || "Unknown",
                item.coupenCode ?? "-",
            ];
        });

        autoTable(doc, {
            startY: 20,
            head: [head],
            body,
            styles: { fontSize: 9 },
            headStyles: { fillColor: [22, 160, 133] },
        });

        doc.save("Full-Booking-Data-transaction.pdf");
    };

    const columns = [
        {
            title: 'Index',
            dataIndex: 'index',
            render: (_: any, __: any, index: number) => index + 1,
        },
        // { title: 'paymentamount', dataIndex: 'paymentamount' },
        // { title: 'paymentstatus', dataIndex: 'paymentstatus' },
        { title: 'createdAt', dataIndex: 'createdAt' },
        {
            title: 'user name',
            dataIndex: 'bookingId',
            render: (bookingId: number) => {
                const course = bookingData.find((c: any) => c.bookingId === bookingId);
                return course ? course?.bookingdetails?.UserName : 'Unknown';
            }
        },

        { title: 'Amount', dataIndex: 'paymentamount' },
        {
            title: 'Payment Status',
            dataIndex: 'paymentstatus',
            render: (status: string) => {
                const color = status.toLowerCase() === 'success' ? 'green' : 'red';
                return <span style={{ color, fontWeight: 'bold', textTransform: 'capitalize' }}>{status}</span>;
            },
        },
        {
            title: 'Course',
            dataIndex: 'bookingdetails',
            render: (bookingdetails: any) => {
                const courseId = bookingdetails?.Course_id;
                const course = courses.find((c: any) => c.id === courseId); // Note: course.id matches bookingdetails.Course_id
                return course ? course.course_title : 'Unknown';
            }
        },
        { title: 'Coupon Code', dataIndex: 'coupenCode' },

    ];

    return (
        <div>
            <LayoutHeader />
            <h1 className="text-2xl font-bold text-center">Payment Transaction Data</h1>

            <Card>
                <h2 className="text-center mt-4">Payment Transaction List</h2>
                <Card className="mb-4">
                    <Form
                        form={form}
                        layout="inline"
                        onFinish={filterBookingData}
                        style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}
                    >

                        <Form.Item label="Month" name="month">
                            <Select placeholder="Select Month" allowClear style={{ minWidth: 150 }}>
                                {[
                                    'January', 'February', 'March', 'April', 'May', 'June',
                                    'July', 'August', 'September', 'October', 'November', 'December'
                                ].map((month, index) => (
                                    <Select.Option key={index + 1} value={index + 1}>
                                        {month}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>

                        {/* Year Selector */}
                        <Form.Item label="Year" name="year">
                            <Select placeholder="Select Year" allowClear style={{ minWidth: 120 }}>
                                {[2022, 2023, 2024, 2025, 2026, 2027, 2028].map((year) => (
                                    <Select.Option key={year} value={year}>
                                        {year}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>

                        <Form.Item>
                            <Button type="primary" htmlType="submit">Filter</Button>
                            <Button
                                style={{ marginLeft: 8 }}
                                onClick={() => {
                                    form.resetFields();
                                    setFilteredData([]);
                                }}
                            >
                                Reset
                            </Button>
                        </Form.Item>
                    </Form>
                </Card>


                <Button
                    type="primary"
                    onClick={() => downloadFullTableAsPDF(filteredData.length > 0 ? filteredData : bookingData, courses)}
                    style={{ marginBottom: 16 }}
                >
                    Download Full Table as PDF
                </Button>

                <Table
                    columns={columns}
                    dataSource={filteredData.length > 0 ? filteredData : bookingData}
                    loading={isLoading}
                    pagination={{ pageSize: 10 }}
                    rowKey="id"
                    scroll={{ x: 'max-content' }}
                />
            </Card>
        </div>
    );
}

export default PaymentDetails;
